<template>
  <div class="gift">
    <div class="title">
      <div class="titleT">场景化礼品定制</div>
      <div class="titleA"><a href="gift.html">立即体验<span class="iconfont icon-shuangjiantou"></span></a></div>
    </div>
    <ul>
      <li v-for="(i,index) in list" :key="index">
        <div class="img"><img :src="i.img"></div>
        <div class="name">{{i.name}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'gift',
  data () {
    return {
      list: [{
        name: '商务礼赠场景',
        img: require('../../../assets/img/index/gift1.png'),
        url: ''
      }, {
        name: '会议场景',
        img: require('../../../assets/img/index/gift2.png'),
        url: ''
      }, {
        name: '促销场景',
        img: require('../../../assets/img/index/gift3.png'),
        url: ''
      }, {
        name: '活动场景',
        img: require('../../../assets/img/index/gift4.png'),
        url: ''
      }]
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.gift
  padding 0 px(20)
  ul
    display flex
    margin-top px(40)
    justify-content space-between
    li
      width px(170)
      position relative
      .name
        position absolute
        bottom 0rem
        height px(40)
        width 100%
        background rgba(0,0,0,.5)
        font-size px(24)
        color #fff
        text-align center
      .img
        padding-bottom 100%
        position relative
        img
          width 100%
          height 100%
          position absolute
          top 0px
          left 0px
          object-fit cover
</style>



// WEBPACK FOOTER //
// src/pages/index/components/gift.vue